import React, { useState } from 'react';
import { 
  Typography, 
  TextField, 
  Button, 
  Card, 
  CardContent,
  Box,
  Paper,
  CircularProgress,
  Container
} from '@mui/material';

const BCBAGoalGenerator = () => {
  const [topic, setTopic] = useState('');
  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateGoals = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/api/generateGoals', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ topic }),
      });
      if (!response.ok) {
        throw new Error('Failed to generate goals');
      }
      const data = await response.json();
      setGoals(data.goals);
    } catch (error) {
      console.error('Error generating goals:', error);
      setError('Failed to generate goals. Please try again.');
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={0} sx={{ p: 4, backgroundColor: 'white' }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            What do you want them to learn?
          </Typography>
          <TextField
            fullWidth
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            placeholder="e.g., token economy system"
            variant="outlined"
            sx={{ 
              backgroundColor: 'white',
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'primary.main',
                },
                '&:hover fieldset': {
                  borderColor: 'primary.dark',
                },
              },
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={generateGoals}
            disabled={loading || !topic}
            sx={{ mt: 2 }}
          >
            Generate Goals
          </Button>
        </Box>
        {loading && <CircularProgress />}
        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
        {goals.length > 0 && (
          <Box>
            <Typography variant="h5" gutterBottom>
              Generated Parent Training Goals and Mastery Criteria
            </Typography>
            {goals.map((goal, index) => (
              <Card 
                key={index} 
                sx={{ 
                  mb: 2, 
                  border: 1, 
                  borderColor: 'primary.main',
                  boxShadow: 'none'
                }}
              >
                <CardContent>
                  <Typography variant="h6">{goal.title}</Typography>
                  <Typography><strong>Goal:</strong> {goal.goal}</Typography>
                  <Typography><strong>Mastery Criteria:</strong> {goal.masteryCriteria}</Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default BCBAGoalGenerator;